<template>
  <div class="header">
    <div class="fr">
      <div class="fr pd-top3">
        <!-- <a href="/" target="_blank">首页</a> -->
      </div>
      <div class="menu fr">
        <el-link href="/" target="_blank" :underline="false">首页</el-link>
        <el-link v-for="(item, index) in techClassList" :key="index" :underline="false"
          :href="'/article/list-' + item.id + '.html?name='+item.name">{{ item.name }}</el-link>
        <!-- <el-link :underline="false" href="/article/list">NET</el-link>
        <el-link :underline="false" href="/article/list">前端</el-link> -->
        <!-- <el-link :underline="false">练习题</el-link>
        <el-link :underline="false">免费接口</el-link> -->
        <!-- <el-dropdown>
          <span class="el-dropdown-link">
            能力测评<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item><el-link :underline="false">
                Java开发能力测评</el-link></el-dropdown-item>
            <el-dropdown-item><el-link :underline="false">
                Net开发能力测评</el-link></el-dropdown-item>
            <el-dropdown-item><el-link :underline="false">
                前端开发能力测评</el-link></el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
        <el-dropdown>
          <span class="el-dropdown-link">
            思维导图<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item><el-link :underline="false" href="/xmind/MySQL.xmind">
                MySQL.xmind</el-link></el-dropdown-item>
            <el-dropdown-item><el-link :underline="false" href="/xmind/CSharp.xmind">
                C#.xmind</el-link></el-dropdown-item>
            <!-- <el-dropdown-item><el-link :underline="false">
                前端开发能力测评</el-link></el-dropdown-item> -->
          </el-dropdown-menu>
        </el-dropdown>
        <el-link :underline="false" href="/talkjob">聊工作</el-link>
      </div>
      <div class="fr ml16 search-box">
        <el-autocomplete prefix-icon="el-icon-search" class="inline-input" v-model="keyword" :fetch-suggestions="querySearch"
          :trigger-on-focus="false" placeholder="请输入内容" @select="handleSubmit" @keyup.enter.native="handleSubmit"
          @input="changeStyle('block', '.el-autocomplete-suggestion')"
          @keyup="changeStyle('block', '.el-autocomplete-suggestion')" size="medium"></el-autocomplete>
      </div>
    </div>
    <div class="h-left">
      <div class="avatar" v-show="showuser">
        <a href="/user/center" target="_blank">
          <el-avatar :size="sizeList[2]" :src="circleUrl"></el-avatar>
        </a>
      </div>
      <div class="noavater">
        <router-link to="/user/center" v-show="showuser">{{
          username
        }}</router-link>
        <span class="divider" v-show="showuser">|</span>
        <router-link to="/login" target="_blank" v-show="!showuser">登录</router-link>
        <span class="divider" v-show="!showuser">|</span>
        <el-badge v-if="msgcount > 0" :value="msgcount" class="item">
          <router-link :to="{ path: '/user/center', query: { ref: 'msg' } }" target="_blank">消息</router-link>
        </el-badge>
        <router-link v-if="msgcount == 0" :to="{ path: '/user/center', query: { ref: 'msg' } }" target="_blank">消息
        </router-link>
        <span class="divider" v-show="showuser">|</span>
        <router-link to="/logout" target="_blank" v-show="showuser">退出</router-link>
        <span class="divider" v-show="!showuser">|</span>
        <router-link to="/reg" v-show="!showuser" target="_blank">注册</router-link>
        <span class="divider">|</span>
        <!-- <el-button type="primary" target="_blank" @click="joinin()"
        >申请加入</el-button
      > -->
      </div>
    </div>
    <div class="clear"></div>
  </div>
</template>

<style scoped>
a {
  font-size: 14px;
  color: #666;
}

.logo {
  vertical-align: middle;
}

.search-box {
  height: 46px;
  padding-top: 6px;
}

.pd-top3 {
  padding-top: 3px;
}

a:hover {
  color: #409EFF;
  text-decoration: underline;
}

/* .el-link.el-link--default:hover {
  color: #666;
} */
.clear {
  clear: both;
}

.fr {
  float: left;
}

.menu {
  height: 46px;
  text-align: center;
}

.el-link {
  height: 100%;
  margin-left: 20px;
}

.divider {
  margin-left: 8px;
  margin-right: 8px;
  color: #ccc;
}

.header {
  background-color: white;
  border-bottom: 1px solid #e3e3e3;
  box-shadow: 0 0 2px #e3e3e3;
  margin-bottom: 0px;
  padding-left: 4px;
}

.h-left {
  float: right;
  padding-top: 9px;
  padding-right: 16px;
  position: relative;
}

.avatar {
  float: left;
  margin-right: 5px;
  padding-top: 0px;
}

.noavater {
  float: left;
  height: 40px;
  padding-top: 3px;
  margin-left:30px;
}

.el-badge {
  vertical-align: inherit;
}
.el-dropdown{margin-left:20px;}
.el-dropdown-link {
    cursor: pointer;
  }
.el-dropdown-menu .el-link{margin-left:0px;}
.el-autocomplete{}
</style>

<script>
import "../assets/css/common.css";
import TechClassApi from '../api/TechClassApi';
import ArticleListApi from '../api/ArticleListApi';

export default {
  data() {
    return {
      circleUrl:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      squareUrl:
        "https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png",
      sizeList: ["large", "medium", "small"],
      username: localStorage.getItem("name"),
      msgcount: 0,
      techClassList: [],
      keyword: '',
    };
  },
  mounted() {
    this.getMsgCount();
    this.getUserInfo();
    this.getTechClassList();
    var keyword = this.$route.query.kw;
    if (keyword == undefined || keyword == null) keyword = '';
    this.keyword = keyword;
  },
  computed: {
    showuser: function () {
      if (this.username == null || this.username == "") return false;
      else return true;
    },
  },
  methods: {
    getTechClassList() {
      TechClassApi.getTechClassList().then(res => {
        this.techClassList = res.data;
      });
    },
    //queryString, cb
    querySearch(keyword, cb) {
      //搜索建议
      // var restaurants = this.restaurants;
      ArticleListApi.getArticleList(0, 1, keyword).then(res => {
        var results = [];
        res.data.data.forEach(item => {
          results.push({ "value": item.title });
        });
        cb(results);
      });
      // // 调用 callback 返回建议列表的数据
      // cb(results);
    },
    //根据传进来的状态改变建议输入框的状态（展开|隐藏）
    changeStyle(status, className) {
      let dom = document.querySelectorAll(className);
      dom[0].style.display = status;
    },
    handleSubmit() {
      this.changeStyle("none", ".el-autocomplete-suggestion");
      location.href = "/?kw=" + this.keyword;
      //this.$router.push({ path: "/", query: { kw: this.keyword } });
    },
    getUserInfo() {
      //通过判断用户名是否为空来判断是否已经登录
      if (this.username == null || this.username == "") return;
      //登录过期也会进来这里，登录过期之后就会自动跳转到登录页面，
      //这样也没有什么问题，登录过期说明该用户有用户名和密码，重新登录一下既可
      //不需要改动啥
      this.$http
        .get("/api/userauth/")
        .then((r) => {
          if (r.data.photo != null) {
            if (this.GLOBAL.isOnLine) {
              this.circleUrl = this.GLOBAL.baseURL + r.data.photo;
            } else {
              this.circleUrl = this.GLOBAL.localBaseURL + r.data.photo;
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getMsgCount() {
      let token = localStorage.getItem("Authorization");
      //未登录
      if (token === null || token === "") {
        return;
      }

      this.$http
        .get("/api/message/0")
        .then((res) => {
          this.msgcount = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    joinin() {
      this.$router.push({ path: "/user/center", query: { ref: "join" } });
    },
  },
};
</script>